import { customerPortal } from "@vilocnv/allsetra-core";
import axiosInstance from "app/axiosInstance";

type DeleteGeozoneRequestDto = customerPortal.geozones.DeleteGeozoneRequestDto;

export const deleteGeozone = async (payload: DeleteGeozoneRequestDto) => {
  try {
    const { accountId, accountGeoFenceId } = payload;
    const response = await axiosInstance.delete(
      `/accounts/${accountId}/geozones/${accountGeoFenceId}`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
